import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=09cc25aa"
import script from "./CouponsTable.vue?vue&type=script&lang=js"
export * from "./CouponsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports